import { createContext } from "react";

interface IPrimaryColor{
    primaryColor: any;
    setPrimaryColor: any;
}

const PrimaryColorContext = createContext<IPrimaryColor>(null!);

export default PrimaryColorContext;